import React, { useEffect } from 'react';
import './MarketOverview.css';

const MarketOverview = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://api.tgju.org/v1/widget/v2";
    script.defer = true;
    script.crossOrigin = "anonymous"; 
    script.onload = () => {
      console.log("TGJU script loaded successfully");
    };
    script.onerror = (e) => {
      console.error("Failed to load TGJU script:", e.message || e);
    };
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    window.onerror = function (message, source, lineno, colno, error) {
      if (message.toLowerCase().includes('script error')) {
        console.warn("Suppressed cross-origin script error:", message);
        return true; 
      }
      return false;
    };
  }, []);
  
  

  return (
    <div className="market-overview">
      <h2 className="section-title">شاخص‌های اقتصادی</h2>
      <div className="market-overview-container">
        <div
          className="chart-wrapper"
          dangerouslySetInnerHTML={{
            __html: `
              <tgju
                type="market-overview"
                items="137137,137138,137139,137140"
                columns="dot"
                token="webservice"
                styles='{"dot": "#0064BD"}'
              ></tgju>
            `,
          }}
        />
        <div
          className="chart-wrapper"
          dangerouslySetInnerHTML={{
            __html: `
              <tgju
                type="market-overview"
                items="137121,391292,137122,391295"
                columns="dot"
                token="webservice"
                styles='{"dot": "#0064BD"}'
              ></tgju>
            `,
          }}
        />
        <div
          className="chart-wrapper"
          dangerouslySetInnerHTML={{
            __html: `
              <tgju
                type="market-overview"
                items="137205,137207,137206,137222"
                columns="dot"
                token="webservice"
                styles='{"dot": "#0064BD"}'
              ></tgju>
            `,
          }}
        />
      </div>
    </div>
  );
};

export default MarketOverview;
